<template>
  <vx-card class="mt-2 pagebreak-inside-avoid">
    <table class="table table-bordered">
      <tr class="title p-1 w-full">
        <th colspan="12">ENDEREÇO DE PERNOITE</th>
      </tr>
      <tr>
        <td class="pl-3">
          <b>CEP</b>:
          {{
            quotationData.overnight_address.zip_code
              ? quotationData.overnight_address.zip_code
              : ''
          }}
        </td>
        <td class="pl-3">
          <b>Endereço</b>:
          {{
            quotationData.overnight_address.street
              ? quotationData.overnight_address.street
              : ''
          }}
        </td>
        <td class="pl-3">
          <b>Número</b>:
          {{
            quotationData.overnight_address.number
              ? quotationData.overnight_address.number
              : ''
          }}
        </td>
        <td class="pl-3">
          <b>Complemento</b>:
          {{
            quotationData.overnight_address.complement
              ? quotationData.overnight_address.complement
              : ''
          }}
        </td>
      </tr>
      <tr>
        <td class="pl-3">
          <b>Bairro</b>:
          {{
            quotationData.overnight_address.neighborhood
              ? quotationData.overnight_address.neighborhood
              : ''
          }}
        </td>
        <td class="pl-3">
          <b>Cidade</b>:
          {{
            quotationData.overnight_address.city
              ? quotationData.overnight_address.city
              : ''
          }}
        </td>
        <td class="pl-3" colspan="2">
          <b>Estado</b>:
          {{
            quotationData.overnight_address.state
              ? quotationData.overnight_address.state
              : ''
          }}
        </td>
        <td colspan="4"></td>
      </tr>
    </table>
    <div
      v-if="customSectionsMsgs.OVERNIGHT_ADDRESS"
      style="text-align: justify"
      class="pl-3 pt-3"
      v-html="customSectionsMsgs.OVERNIGHT_ADDRESS"
    ></div>
  </vx-card>
</template>

<script>
export default {
  name: 'EndorsementContractOvernightAddress',
  props: {
    quotationData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
};
</script>
